import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/plugins/vue-i18n'

import '@/plugins/element-ui'
import '@/plugins/vue-cookie'
import '@/plugins/vue-fragment'
import '@/plugins/vue-prototype'
import '@/plugins/vue-inline-svg'
import '@/plugins/vue-observe-visibility'
import '@/plugins/session'

import '@/mixins/error'
import '@/directive/next-focus'
import '@/directive/safe-html'
import '@/directive/replace-half-width'
import '@/plugins/vue-meta'

import '@/assets/css/themes/index.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/main.scss'

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
